/*
 * SIE conversion attribution — browser side.
 *
 * A visitor arriving from a tracked social link carries `sie_vid` in the query
 * string (and a cookie, when the cookie domain is configured). We persist it
 * locally so the funnel event can be reported at signup, which may be several
 * sessions later than the click.
 */
import axios from 'axios';

const API_BASE = window.location.hostname === 'localhost' || window.location.hostname === '127.0.0.1'
  ? 'http://localhost:3003'
  : 'https://api.blockhivetechnologies.com';

const KEY = 'sie_visitor_id';

/** Capture the visitor id from the landing URL. Safe to call on every render. */
export function captureVisitor() {
  try {
    const fromUrl = new URLSearchParams(window.location.search).get('sie_vid');
    if (fromUrl && /^[a-f0-9]{8,64}$/.test(fromUrl)) {
      localStorage.setItem(KEY, fromUrl);
      return fromUrl;
    }
    const fromCookie = document.cookie.match(/sie_vid=([a-f0-9]+)/);
    if (fromCookie) {
      localStorage.setItem(KEY, fromCookie[1]);
      return fromCookie[1];
    }
  } catch (_) { /* private mode / storage disabled */ }
  return getVisitor();
}

export function getVisitor() {
  try { return localStorage.getItem(KEY); } catch (_) { return null; }
}

/**
 * Report a funnel event. Never throws and never blocks the caller — a failed
 * analytics ping must not interfere with the user actually signing in.
 *
 * @param {'signup'|'trial'|'premium'} event
 * @param {string} [identity]  email or wallet address, once known
 * @param {number} [value]     subscription value, for 'premium'
 */
export function recordConversion(event, identity, value) {
  const visitor_id = getVisitor();
  if (!visitor_id) return Promise.resolve(null);
  return axios
    .post(`${API_BASE}/sie/conversion`, { visitor_id, event, identity, value }, { timeout: 6000 })
    .catch(() => null);
}
